import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { EmailVerificationModalBody } from './components/EmailVerificationModalBody';

export const useEmailVerificationModal = createModalHook<{
	path: string;
	showContinueAsGuest: boolean;
	userId: string;
}>({
	name: 'PromotePageEmailVerificationModal',
	stylesOverrides: {
		width: 420,
	},
	body: function PromotePageEmailVerificationModalBody({ options, closeModal }) {
		return (
			<div className="px-2 pt-16" data-qa="verify-email-modal">
				<EmailVerificationModalBody
					path={options.path}
					onContinueAsGuest={options.showContinueAsGuest ? () => closeModal() : undefined}
					userId={options.userId}
				/>
			</div>
		);
	},
});
